import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { call } from '@packages/functions';
import { useApp } from '@packages/hooks/useApp';
import { RouterServiceProvider } from '@packages/router/lib/RouterServiceProvider';
import * as React from 'react';

interface NavigateBackProps {
    children?: any;
    fallbackHref?: string;
    fallbackProps?: { [key: string]: any };
}

export const NavigateBack = React.memo<NavigateBackProps>((props: any) => {
    const { children, fallbackHref, fallbackProps, ...rest } = props;

    const router$ = useApp(RouterServiceProvider);

    const children$ = children ? (
        children
    ) : (
        <IconButton>
            <Icon>arrow_back</Icon>
        </IconButton>
    );

    const handleClick = React.useCallback(
        async (e) => {
            await call(rest.onClick, e);
            await call(children$.props.onClick, e);
            router$.goBack(fallbackHref, fallbackProps);
        },
        [rest.onClick, children$.props.onClick, fallbackHref, fallbackProps],
    );

    return {
        ...children$,
        props: {
            ...children$.props,
            ...rest,
            disabled: router$.history.length <= 1 && !fallbackHref,
            onClick: handleClick,
        },
    };
});

NavigateBack.displayName = 'NavigateBack';
